import { Button } from "primereact/button"
import { useNavigate } from "react-router-dom"

const CreateElaborationButton = () =>{
    const navigate = useNavigate()

    const handlePage = (e)=>{
        e.preventDefault()
        navigate('/dashboard/new_elaboration')
    }
    return (
        <Button onClick={handlePage} style={{textAlign:'start'}}>Crea</Button>
    )
}

export default CreateElaborationButton